import { render, staticRenderFns } from "./ProductIntroduction.vue?vue&type=template&id=ae71bafe&scoped=true&"
import script from "./ProductIntroduction.vue?vue&type=script&lang=js&"
export * from "./ProductIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroduction.vue?vue&type=style&index=0&id=ae71bafe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae71bafe",
  null
  
)

export default component.exports